// extracted by css-extract-rspack-plugin
export default {"spinnerWrapper":"_2976538d"};